@if (isLoading) {
<app-loading-spinner text="Lot Details"></app-loading-spinner>
} @if (userDetails$ | async; as user) {
<div class="py-2 px-4 page-height overflow-auto">
  @if (lot$ | async; as data) {
  <div class="pb-20">
    <div class="row">
      @if (negotiating()) {
      <div class="w-full mx-auto max-w-2xl my-3">
        <div class="flex flex-row px-3 justify-between">
          <span class="text-base font-base">Active Negotiations</span>
          <fa-icon
            [icon]="faHandShake"
            size="lg"
            [style]="{ color: '#ff9500', padding: '5px' }"
          ></fa-icon>
        </div>
        <div class="">
          @for (negotiation of negotiations(); track negotiation; let i =
          $index) {
          <mat-card
            appearance="outlined"
            class="my-card counter-card my-1 w-full font-medium hover:cursor-pointer mobile-max:text-sm"
            (click)="router.navigate(['app/negotiations', negotiation._id])"
          >
            <mat-card-content [ngClass]="{ 'not-active': i != 0 }">
              <div
                class="flex flex-row gap-4 justify-between items-center mobile-max:px-1 px-4"
              >
                <div>
                  @if (negotiation.counters[0].originator_id) {
                  <mat-chip-set>
                    <mat-chip
                      aria-label="sent-counter"
                      disableRipple="true"
                      defaultColor="red"
                      class="text-xs light-blue-chip font-normal"
                    >
                      Negotiation
                    </mat-chip>
                    @if (data.status === 'Declined') {
                    <mat-chip class="red-chip text-xs"> Declined </mat-chip>
                    }
                  </mat-chip-set>
                  } @if ( negotiation.counters[0].ship_begin != null &&
                  negotiation.counters[0].ship_end != null) {
                  <div class="flex flex-col flex-wrap">
                    {{ negotiation.counters[0].ship_begin | date : "MMM d, y" }}
                    -
                    {{ negotiation.counters[0].ship_end | date : "MMM d, y" }}
                  </div>
                  } @else {
                  <div class="flex flex-col flex-wrap">
                    <span class="opacity-60 tablet-min:text-md text-xs"
                      >Shipping</span
                    >
                    {{ data.ship_begin_orig | date : "MMM d, y" }} -
                    {{ data.ship_end_orig | date : "MMM d, y" }}
                  </div>
                  }
                </div>
                <div
                  class="flex flex-col items-start font-base justify-center flex-nowrap"
                >
                  <span>
                    {{ data.currency }}
                    $
                    {{ negotiation.counters[0].price_value | priceType }}
                    /
                    {{ data.price_units }}
                  </span>
                  <span>
                    {{ negotiation.counters[0].volume_value }}
                    {{ data.units == "Metric Tonnes" ? "MT" : data.units }}
                  </span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          }
        </div>
      </div>
      }
      <div class="px-3 w-full mx-auto max-w-2xl">
        <div class="flex flex-row justify-between items-center">
          <div class="text-xl font-medium">
            {{ data.commodity }}
            @if (data.product_type) {
            <span>- {{ data.product_type }}</span>
            } -
            {{ data.grade }}
          </div>
          <mat-chip-set class="flex flex-row pl-2 items-start text-xs">
            <mat-chip
              class="text-xs"
              [ngClass]="{
                'red-chip': data.status === 'Cancelled',
                'green-chip': 'Active' === data.status,
                'grey-chip': data.status === 'Expired'
              }"
              >{{ data.status }}</mat-chip
            >
            @if (user._id == data.user_id) {
            <mat-chip
              aria-label="sent-counter"
              disableRipple="true"
              class="text-xs bg-custom-blue purple-chip p-0"
              >My
            </mat-chip>
            } @if(!data.broker_indication){
            <mat-chip
              style="margin-left: 4px !important"
              disableRipple="true"
              [ngClass]="{
                'blue-chip': data.lot_type === 'Offer',
                'green-chip': data.lot_type === 'Bid'
              }"
            >
              {{ data.lot_type }}
            </mat-chip>
            } @if (data.indication && !data.broker_indication) {
            <mat-chip disableRipple="true" class="text-xs light-blue-chip p-0"
              >Indication
            </mat-chip>
            }
            <app-jc-trading-indication
              [showIndication]="data.broker_indication"
            ></app-jc-trading-indication>
          </mat-chip-set>
        </div>
      </div>
      <mat-card class="px-4 mobile-max:px-2 mx-auto max-w-2xl">
        <mat-card-content class="w-full">
          <div class="px-2 w-full">
            <div id="details-grid" class="my-2 w-full grid grid-cols-2">
              @if(user._id == data.user_id && data.status === 'Active' &&
              negotiating() == false){
              <fa-icon
                class="col-span-1 col-start-2 justify-self-end hover:cursor-pointer"
                [icon]="faEdit"
                size="md"
                (click)="editLot()"
              ></fa-icon>
              }

              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Origin
              </div>
              <div class="font-medium">{{ data.origin }}</div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Specifications
              </div>
              <div class="font-medium">
                @for (spec of data.specifications; track spec) { @if (spec.value
                !== '') {
                <span> {{ spec.title }} - {{ spec.value }} <br /> </span>
                } }
              </div>
              @if(data.documentations && data.documentations.length){
              <div class="text-sm light:text-gray-300">Documentations</div>
              <div
                class="font-medium text-base czol-span-2 doc-container text-right"
              >
                @for (doc of data.documentations; track doc) { @if (doc.value
                !== null) {
                <p class="text-left doc-row">
                  {{ doc.title }} -
                  <span class="font-normal text-sm">{{ doc.value }}</span>
                </p>
                } }
              </div>
              }
              <div
                class="font-base tablet-max:text-sm text-base light:text-gray-300"
              >
                Price
              </div>
              <div class="font-medium">
                @if(data.indication){~}
                {{ data.currency }}
                $ {{ data.price | priceType }}
                /
                {{ data.price_units }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Volume
              </div>
              <div class="font-medium">
                {{ data.volume_value | number }}
                {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Delivery Type
              </div>
              <div class="font-medium">
                {{ data.delivery_type }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Location
              </div>
              <div style="text-wrap: wrap" class="font-medium">
                {{ data.destination }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Shipping
              </div>
              <div class="font-medium">
                <div>
                  {{ data.ship_begin | date : "MMM d, y" }} -
                  {{ data.ship_end | date : "MMM d, y" }}
                </div>
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Rules to Govern
              </div>
              <div class="font-medium">
                {{ data.rules_to_govern }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Grades/Weights to Govern
              </div>
              <div class="font-medium">
                {{ data.weight_grade_to_govern }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Container Tpe
              </div>
              <div class="font-medium">
                {{ data.container_type }}
              </div>
              <div class="tablet-max:text-sm text-base light:text-gray-300">
                Payment terms
              </div>
              <div class="font-medium">
                {{ data.payment_term }}
              </div>
              <div
                class="tablet-max:text-sm text-base light:text-gray-300"
                style="border-color: transparent"
              >
                Additional Notes
              </div>
              <div class="font-medium" style="border-color: transparent">
                {{ data.additional_info || "-" }}
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <br />
    </div>
    @if(!data.broker_indication){
    <div
      class="text-white fixed bottom-6 pointer-events-auto left-0 right-0 flex justify-center flex flex-row flex-wrap gap-2 justify-center items-center"
    >
      @if (user._id == data.user_id && data.status === 'Active') {
      <button
        class="cursor-pointer button-transition bg-custom-danger text-md p-4 rounded-full w-40 text-white"
        (click)="revoke(data._id)"
      >
        Revoke
      </button>
      } @if (user._id == data.user_id && data.status !== 'Active') {
      <button
        class="cursor-pointer button-transition bg-custom-blue text-md p-4 rounded-full w-40"
        (click)="repost(data._id)"
      >
        Repost
      </button>
      } @if (market$ | async; as marketType) { @if ( data.user_id != user._id &&
      !negotiating() && data.status === 'Active' && canNegotiateAndAccept() &&
      marketType !== 'Farm' ) {
      <div
        class="hover:cursor-pointer button-transition bg-custom-green text-md p-4 rounded-full flex items-center justify-center w-40"
        [style.opacity]="buttonOpacity"
        (click)="counter()"
      >
        Counter
      </div>
      } }
      <!-- </div> -->
      @if (data.user_id != user._id && canNegotiateAndAccept()) {
      <button
        type="button"
        class="button-transition bg-custom-blue text-md p-4 rounded-full flex items-center justify-center w-40"
        [style.opacity]="buttonOpacity"
        (click)="accept()"
      >
        Accept
      </button>
      }
    </div>
    }
  </div>
  }
</div>
}
